export default {"src":"/_next/static/media/greencabbage.9316fab4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};